import {Baseball} from "sb-resp-ui";
/**
 * BaseballConstants defines constants related to baseball sport
 * @const array of displayed inning indexes
 * @const mapping of baseball types and components
 */

 export const DisplayedBaseballInnings = ["1","2","3","4","5","6","7","8","9"];

export const ScoreboardTypes = {
    BaseballScoreboard: Baseball
}

export enum ScoreboardType {
    Default = "DefaultScoreboard",
    Baseball ="BaseballScoreboard"
}

export enum BaseballCurrentBattingTeam {
    Home = 1,
    Away = 2
}